import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-red/20" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CountdownBar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <StatsBar data-id="element-5" />
        <TransformationSection data-id="element-6" />
        <PainPointsSection data-id="element-7" />
        <KitContentsSection data-id="element-8" />
        <InstantAccessSection data-id="element-9" />
        <BonusesSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTASection data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <SocialProofPopup data-id="element-17" />
    </div>;
}